import { Translate } from '@chipinside/translate'

interface IParams {
  format_file: string
}

export const buildFileField = ({ format_file }: IParams) => ({
  accept: format_file,
  label: Translate({ messageKey: 'file' }),
  name: 'import',
  placeholder: Translate({
    messageKey: 'select_one_item_male',
    params: { item: Translate({ lower: true, messageKey: 'file' }) },
  }),
  rules: {
    required: {
      message: Translate({
        messageKey: ['required_field', 'file'],
        separator: ' - ',
      }),
      value: true,
    },
  },
  type: 'file',
})
